export default __webpack_public_path__ + "static/media/banner.268c344d.png";